<template>
  <div id="login">
    <v-toolbar dense flat height="20px" color="primary"></v-toolbar>

    <v-content>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center" mt-5>
            <h1>
              <img :src="require(`@/assets/${imgTopo}`)" alt="Imagem Topo" class="mb-5" />
            </h1>
            <h1>Redefinir Senha</h1>
          </v-flex>
          <v-flex xs12 sm6 offset-sm3 mt-3>
            <form>
              <v-layout column>
                <v-flex>
                  <v-text-field
                    v-model="reset.email"
                    append-icon="email"
                    name="email"
                    label="Email"
                    id="email"
                    type="text"
                    required
                    autofocus
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="reset.password"
                    :rules="senhaRules"
                    name="password"
                    label="Senha"
                    id="password"
                    :type="show1 ? 'text' : 'password'"
                    mask="######"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    required
                    counter="6"
                    @click:append="show1 = !show1"
                  ></v-text-field>
                  <v-text-field
                    v-model="reset.password_confirmation"
                    :rules="senhaRules"
                    name="password_confirmation"
                    label="Confirmação da Senha"
                    id="password_confirmation"
                    :type="show2 ? 'text' : 'password'"
                    mask="######"
                    :append-icon="show2 ? 'visibility' : 'visibility_off'"
                    @click:append="show2 = !show2"
                    counter="6"
                    required
                  ></v-text-field>
                  <input type="hidden" id="token" v-model="reset.token" />
                  <!--<div class="error" v-if="!$v.login.senha.required">Validação </div>-->
                </v-flex>
                <v-progress-linear color="carregando" v-show="loading" :indeterminate="true"></v-progress-linear>
                <v-flex class="text-xs-center">
                  <v-btn color="primary" large @click="resetSenha()" type="button">Concluir</v-btn>
                </v-flex>
              </v-layout>
            </form>

            <v-snackbar
              :timeout="tempo"
              :color="error"
              :multi-line="'multi-line'"
              :vertical="mode === 'vertical'"
              v-model="snackbar"
            >
              {{ textSnack }}
              <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
            </v-snackbar>

            <v-snackbar
              :timeout="5000"
              :color="sucesso"
              :multi-line="'multi-line'"
              :vertical="mode === 'vertical'"
              v-model="snackbarSuccess"
            >
              {{textSnackSuccess}}
              <v-btn dark flat @click.native="snackbarSuccess = false">Fechar</v-btn>
            </v-snackbar>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <template></template>
  </div>
</template>

<script>
import { HTTP } from "../services/http.axios.js";
import { required, minLength, between } from "vuelidate/lib/validators";

export default {
  name: "ResetSenha",
  props: ["id_token"],
  data() {
    return {
      imgTopo: "",
      reset: {
        email: "",
        password: "",
        password_confirmation: "",
        token: ""
      },
      cpfRules: [
        v => !!v || "Cpf é requerido",
        v => v.length == 11 || "Cpf Menor que o padrão"
      ],
      senhaRules: [v => !!v || "Senha é requerida"],
      textSnack: "",
      textSnackSuccess: "",
      show1: false,
      show2: false,
      snackbar: false,
      snackbarSuccess: false,
      tempo: 5000,
      mode: "",
      info: "f1f1f1",
      error: "error",
      sucesso: "sucesso",
      loading: false,
      dialog: false,
      login: {
        cpf: "",
        senha: ""
      }
    };
  },
  validations: {
    login: {
      cpf: {
        required,
        minLength: minLength(11)
      },
      senha: {
        required
      }
    }
  },
  created() {
    let currentUrl = window.location.hostname;
    let imgUrl = currentUrl.split(".");
    console.log(this.imgUrl);
    if (imgUrl[0] == "omminiprepago") {
      this.imgTopo = "logo.png";
    } else {
      this.imgTopo = imgUrl[0] + ".png";
    }
    console.log(this.imgTopo);
  },
  mounted() {
    window.localStorage.setItem("tituloApp", "OMMINI PRÉ-PAGO");
    this.reset.token = this.id_token;

    //OMMINI Pre Pago
  },
  methods: {
    resetSenha() {
      HTTP.post(`password/reset`, this.reset)
        .then(response => {
          console.log(response.data.message);
          if (response.data.message !== "" && response.data.data !== null) {
            this.textSnack = response.data.message;
            this.snackbar = true;
          } else {
            this.textSnackSuccess = response.data.message;
            this.snackbarSuccess = true;
            setTimeout(function() {}, 5000);
          }

          dialog = false;
        })
        .catch(e => {
          this.loading = false;
          console.log(e.response);

          if (!Array.isArray(e.response.data.errors)) {
            let itens = [];
            for (var prop in e.response.data.errors) {
              itens.push(e.response.data.errors[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.data.errors;
            this.snackbar = true;
          }
        });
    },
    openRota() {
      this.$router.push("Saldo");
    },
    logar() {
      this.loading = true;
      HTTP.post(`users/login/cliente`, this.login)
        .then(response => {
          if (response.data.error) {
            this.textSnack = response.data.error.cpf;
            this.snackbar = true;
          } else {
            window.sessionStorage.setItem("token", response.data.token);
            window.sessionStorage.setItem("nome", response.data.nome);
            window.sessionStorage.setItem("cpf", response.data.cpf_cnpj);
            HTTP.defaults.headers.common[
              "authorization"
            ] = `Bearer ${response.data.token}`;
            setTimeout(() => {
              this.loading = false;
              this.$router.push("Saldo");
            }, 1000);
            //return true;
          }

          //  console.log(response.data.token)
        })
        .catch(e => {
          this.loading = false;
          console.log("log" + e.response.data.error);

          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.data.error;
            this.snackbar = true;
          }
        });

      // this.textSnack = "Informe sua senha"
    }
  }
};
</script>



<style>
#login {
  background-color: "#F1F1F1";
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495e;
}
</style>



// WEBPACK FOOTER //
// src/components/ResetSenha.vue